import { DropDownList } from '@progress/kendo-react-dropdowns'
import toPairs from 'lodash/toPairs'
import * as React from 'react'
import { connect } from 'react-redux'
import {Button, Col, InputGroup, InputGroupAddon, InputGroupText, Row} from 'reactstrap'
import * as NewsbriefTypes from '../types'
import * as NewsbriefUtils from '../utils'
import * as Actions from './actions'
import * as Constants from './constants'
import './styles.css'

interface DispatchProps {
  createColor: NewsbriefTypes.StateAddActionCreator,
  removeColor: NewsbriefTypes.StateDeleteActionCreator,
  selectedPartner: string,
  updateColor: NewsbriefTypes.StateUpdateActionCreator,
}
type Props = DispatchProps & NewsbriefTypes.WrappedConfigurationRows

const ColorPicker =
  ({ rows,
     selectedPartner,
     createColor,
     removeColor,
     updateColor }: Props) =>  {
  const takenColors = rows.filter((item: NewsbriefTypes.ConfigurationRow) => !item.editing.isSyntheticRow)
                          .map((item: NewsbriefTypes.ConfigurationRow) => item.data.key)
  const availableColors = Constants.supportedColorKeys.filter((item: string) => !takenColors.includes(item))
  return (
  <div>
    <Button className="add-color"
      title="Add a color."
      onClick={() => createColor(selectedPartner)}>
      ADD COLOR
    </Button>
    <Row>
      {rows.map((config: NewsbriefTypes.ConfigurationRow, i: number) =>
          <Col className="col-padding" xs="6" key={i}>
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText
                  style={{background: `${config.data.value}`}}
                  className="color-cell">
                </InputGroupText>
              </InputGroupAddon>
              <input
                className="text-box--container width-15"
                onChange={(e) => updateColor({
                    name: config.data.key,
                    property: 'value',
                    rowId: config.rowId,
                    value: e.target.value,
                  })}
                  value={config.data.value}
                />
               {config.editing.isSyntheticRow
               ?
                <DropDownList
                  className="dropdown-override width-50"
                  data={availableColors}
                  onChange={(e) => updateColor({
                    name: config.data.value,
                    property: 'key',
                    rowId: config.rowId,
                    value: e.target.value,
                  })}
                  value={config.data.key} />
                :
                <input
                  readOnly
                  disabled
                  className="text-box--container width-50"
                  value={config.data.key} />
                }
                <div>
                  <Button
                    className="rasa-btn rasa-cancel-btn"
                    onClick={() => removeColor(config.rowId)}>
                      <span className="k-icon k-i-minus-circle" />
                    </Button>
                </div>
            </InputGroup>
          </Col>)}
    </Row>
  </div>);
}

export const ColorPickerConnected = connect(
  ({newsbriefConfigs}: NewsbriefTypes.WrappedState) => (
    {
      rows:
        toPairs(newsbriefConfigs.colors)
          .map(([rowId, {data, editing}]: [string, NewsbriefTypes.Row<NewsbriefTypes.PayloadData>]) =>
            ({rowId, data, editing}))
          .filter(({rowId, data, editing}) =>
            !data.isDefault && data.is_active &&
            NewsbriefUtils.isSelectedPartner(data.partner_code, newsbriefConfigs.configState.selectedPartner)),
      selectedPartner: newsbriefConfigs.configState.selectedPartner,
    }
  ),
  {
    createColor: Actions.addColorRow,
    removeColor: Actions.deleteColor,
    updateColor: Actions.updateColorKey,
  },
)(ColorPicker)



// WEBPACK FOOTER //
// ./src/pages/newsbrief/color-picker/component.tsx